import React, {useEffect} from "react"
import Header from "../../components/header"
import Trade from "../../components/trade"
import { FaTrophy } from 'react-icons/fa'
import teamsData from "../../../static/data/teams.json"
import tradesData from "../../../static/data/trades.json"
import { Chart } from 'chart.js'
import {Helmet} from "react-helmet"
import { generateExpandable, generateHighestScoresList, generateWeeklyPlacesList } from "../../utils/helpers"

function Page({teams}) {
  const season = "2025";
  const teamNames = teamsData.map((team) => team.seasons[season].name);
  const teamColors = teamsData.map((team) => team.color);
  const trades = tradesData[0][season].trades;    

  const highScores = [
    {
      "team": teamNames[3],
      "week": "7",
      "score": "191.18"
    },
    {
      "team": teamNames[8],
      "week": "16",
      "score": "187.1"
    },
    {
      "team": teamNames[3],
      "week": "16",
      "score": "179.32"
    },
    {
      "team": teamNames[8],
      "week": "6",
      "score": "178.3"
    },
    {
      "team": teamNames[3],
      "week": "14",
      "score": "158.06"
    },
    {
      "team": teamNames[9],
      "week": "10",
      "score": "157.52"
    },
    {
      "team": teamNames[0],
      "week": "6",
      "score": "153.34"
    },
    {
      "team": teamNames[3],
      "week": "12",
      "score": "153.28"
    },
    {
      "team": teamNames[7],
      "week": "8",
      "score": "151.76"
    },
    {
      "team": teamNames[9],
      "week": "4",
      "score": "151.56"
    }    
  ];
  
  useEffect(() => {
    const teams = teamsData;  

    new Chart(document.getElementById("chartPF"), {
      type: 'horizontalBar',
      data: {
        datasets: [{
          data: teams.map((team) => team.seasons[season].pointsFor),
          backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: false
        }
      }
    });
    generateExpandable('chartPF-table-container', teams, season, "pointsFor");

    new Chart(document.getElementById("chartPP"), {
      type: 'horizontalBar',
      data: {
        datasets: [{
          data: teams.map((team) => team.seasons[season].pointsPossible),
          backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: false
        }
      }
    });
    generateExpandable('chartPP-table-container', teams, season, "pointsPossible");

    new Chart(document.getElementById("chartPercPP"), {
      type: 'horizontalBar',
      data: {
        datasets: [{
          data: teams.map((team) => team.seasons[season].pointsPossiblePerc),
          backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: false
        }
      }
    });
    generateExpandable('chartPercPP-table-container', teams, season, "pointsPossiblePerc");  

    new Chart(document.getElementById("chartPA"), {
      type: 'horizontalBar',
      data: {
        datasets: [{
          data: teams.map((team) => team.seasons[season].pointsAgainst),
          backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: false
        }
      }
    });
    generateExpandable('chartPA-table-container', teams, season, "pointsAgainst", false);
    
    new Chart(document.getElementById("chartAvgScore"), {
      type: 'horizontalBar',
      data: {
        datasets: [{
          data: teams.map((team) => team.seasons[season].avgScore),
          backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: false
        }
      }
    });
    generateExpandable('chartAvgScore-table-container', teams, season, "avgScore");

    new Chart(document.getElementById("chartTrades"), {
      type: 'horizontalBar',
      data: {
        datasets: [{
            data: teams.map((team) => team.seasons[season].tradeCount),
            backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    });
    generateExpandable('chartTrades-table-container', teams, season, "tradeCount");

    // doesn't pull from array
    new Chart(document.getElementById("chartHighestScore"), {
      type: 'horizontalBar',
      data: {
        datasets: [{
          data: [
            '191.18',
            '187.1',
            '179.32',
            '178.3',
            '158.06',
            '157.52',
            '153.34',
            '153.28',
            '151.76',
            '151.56'
          ],
          backgroundColor: [
            teamColors[3],
            teamColors[8],
            teamColors[3],
            teamColors[8],
            teamColors[3],
            teamColors[9],
            teamColors[0],
            teamColors[3],
            teamColors[7],
            teamColors[9]
          ],
        }],
        labels: [
          teamNames[3] + ' - Week 7',
          teamNames[8] + ' - Week 16',
          teamNames[3] + ' - Week 16',
          teamNames[8] + ' - Week 6',
          teamNames[3] + ' - Week 14',
          teamNames[9] + ' - Week 10',
          teamNames[0] + ' - Week 6',
          teamNames[3] + ' - Week 12',
          teamNames[7] + ' - Week 8',
          teamNames[9] + ' - Week 4'
        ]
      },
      options: {
        legend: {
          display: false
        }
      }
    });
    generateHighestScoresList('chartHighestScore-container','chartHighestScore-container-wrapper',highScores)

    new Chart(document.getElementById("chartAboveAvgPerc"), {
      type: 'polarArea',
      data: {
        datasets: [{
          data: teams.map((team) => team.seasons[season].aboveAvgPerc),
          backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: true,
          position: 'left'
        },
        responsive: true,
      }
    });
    generateExpandable('chartAboveAvgPerc-table-container', teams, season, "aboveAvgPerc");

    new Chart(document.getElementById("chartWeeklyPlaces"), {
      type: 'line',
      data: {
        labels: [
          'Week 1',
          'Week 2',
          'Week 3',
          'Week 4',
          'Week 5',
          'Week 6',
          'Week 7',
          'Week 8',
          'Week 9',
          'Week 10',
          'Week 11',
          'Week 12',
          'Week 13',
          'Week 14',
          'Week 15',
          'Week 16',
          'Week 17'
        ],
        datasets: 
          teams.map((team,idx) => (
            {
              label: team.seasons[season].name,
              data: team.seasons[season].weeklyPlaces,
              fill: false,
              borderColor: team.color,
              backgroundColor: team.color,
              borderCapStyle: 'square'
            }
          ))
      },
      options: {
        legend: {
          display: true,
          position: 'top',
        },
        scales: {
          yAxes: [{
            ticks: {
              reverse: true
            }
          }]
        },
        responsive: true,
      }
    });

    generateWeeklyPlacesList('chartWeeklyPlaces-container', 'chartWeeklyPlaces-wrap', teams, season);

    new Chart(document.getElementById("chartOriginalTeam"), {
      type: 'polarArea',
      data: {
        datasets: [{
            data: teams.map((team) => team.seasons[season].originalTeamPerc),
            backgroundColor: teamColors,
        }],

        labels: teamNames
      },
      options: {
        legend: {
          display: true,
          position: 'left'
        },
        responsive: true,
      }
    });
    generateExpandable('chartOriginalTeam-table-container', teams, season, "originalTeamPerc");

    new Chart(document.getElementById("chartTier1"),{
      type:"horizontalBar",
      data:{
        labels: teamNames,
        datasets:[
          {
            label: "QB",
            data: teams.map((team) => team.seasons[season].tier1_QB.length),
            backgroundColor: "#C62828"
          },
          {
            label: "RB",
            data: teams.map((team) => team.seasons[season].tier1_RB.length),
            backgroundColor: "#2E7D32"
          },
          {
            label: "WR",
            data: teams.map((team) => team.seasons[season].tier1_WR.length),
            backgroundColor: "#1565C0"
          },
          {
            label: "TE",
            data: teams.map((team) => team.seasons[season].tier1_TE.length),
            backgroundColor: "#F9A825"
          },
          {
            label: "D/ST",
            data: teams.map((team) => team.seasons[season].tier1_DST.length),
            backgroundColor: "#6A1B9A"
          }
        ]
      },
      options: {
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
    });
    generateExpandable('chartTier1-table-container', teams, season, "tier1Players");
  }, [teams]) 

  return (
    <React.Fragment>
      <Helmet>
        <title>{season} Season Recap | Chode Dynasty</title>
      </Helmet>
      
      <Header />
      <main>
        <div className="row">
          <div className="inner">
            <h1>{season} Season Recap</h1>
            
            <div className="cols-2">
              <div>
                <h2>Final Standings</h2>

                <ol className="standings">
                  <li>
                    <span className="label">1<sup>st</sup></span> Narcoleptic Skydivers (11-3)
                    <div className="trophy place-1"><FaTrophy /></div>
                  </li>
                  
                  <li>
                    <span className="label">2<sup>nd</sup></span> Charm City Trading Co. (11-3)
                    <div className="trophy place-2"><FaTrophy /></div>
                  </li>
                  
                  <li>
                    <span className="label">3<sup>rd</sup></span> Team jhoffman (8-6)
                    <div className="trophy place-3"><FaTrophy /></div>
                  </li>
                  
                  <li>
                    <span className="label">4<sup>th</sup></span> Human Poop (8-6)
                  </li>
                  
                  <li>
                    <span className="label">5<sup>th</sup></span> Chodemissioner (8-6)
                  </li>
                  
                  <li>
                    <span className="label">6<sup>th</sup></span> Take a poo leave a poo (7-7)
                  </li>
                  
                  <li>
                    <span className="label">7<sup>th</sup></span> Piss Jugman (6-8)
                  </li>
                  
                  <li>
                    <span className="label">8<sup>th</sup></span> D.P. LoveKraft (4-10)
                  </li>
                  
                  <li>
                    <span className="label">9<sup>th</sup></span> Wee Lads (4-10)
                  </li>
                  
                  <li>
                    <span className="label">10<sup>th</sup></span> Stroud's Chodes (3-11)
                  </li>
                </ol>
              </div>

              <div>
                <h2>Champion Roster</h2>
                <table className="styled champ">
                  <thead>
                    <tr>
                      <th>Position</th>
                      <th>Player</th>
                      <th>Points</th>
                    </tr>
                  </thead>
        
                  <tbody>
                    <tr>
                      <td>QB</td>
                      <td>B. Purdy (SF)</td>
                      <td>42.92</td>
                    </tr>
                    <tr>
                      <td>RB</td>
                      <td>D. Achane (MIA)</td>
                      <td>12.70</td>
                    </tr>
                    <tr>
                      <td>RB</td>
                      <td>C. McCaffrey (SF)</td>
                      <td>26.10</td>
                    </tr>
                    <tr>
                      <td>WR</td>
                      <td>J. Jennings (SF)</td>
                      <td>11.20</td>
                    </tr>
                    <tr>
                      <td>WR</td>
                      <td>G. Pickens (DAL)</td>
                      <td>9.80</td>
                    </tr>
                    <tr>
                      <td>TE</td>
                      <td>H. Fannin (CLE)</td>
                      <td>10.00</td>
                    </tr>
                    <tr>
                      <td>WRT</td>
                      <td>J. Meyers (JAX)</td>
                      <td>3.90</td>
                    </tr>
                    <tr>
                      <td>WRT</td>
                      <td>A. Jeanty (LV)</td>
                      <td>8.30</td>
                    </tr>
                    <tr>
                      <td>DST</td>
                      <td>Ravens</td>
                      <td>5.00</td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td><strong>129.92</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div id="awards" className="row">
          <div className="inner">
            <h2>Awards</h2>
            <div className="cols-2">
              <div>
                <h3><span role="img" aria-label="rocket">🚀</span> Highest Scorer</h3>
                <h4>Charm City Trading Co.</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="pile of poo">💩</span>Lowest Scorer</h3>
                <h4>Wee Lads</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="four-leaf clover">🍀</span>Best Luck</h3>
                <div className="desc">(least points against)</div>
                <h4>Narcoleptic Skydivers</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="face with head-bandage">🤕</span>Worst Luck</h3>
                <div className="desc">(most points against)</div>
                <h4>Wee Lads</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="fire">🔥</span>Best Manager</h3>
                <div className="desc">(highest percentage of possible points scored)</div>
                <h4>Narcoleptic Skydivers</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="thinking face">🤔</span>Worst Manager</h3>
                <div className="desc">(lowest percentage of possible points scored)</div>
                <h4>Piss Jugman</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="increasing chart">📈</span>Most Improved</h3>
                <div className="desc">(biggest increase from last season in points for)</div>
                <h4>Narcoleptic Skydivers (+458.92)</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="decreasing chart">📉</span>Least Improved </h3>
                <div className="desc">(biggest decrease from last season in points for)</div>
                <h4>Wee Lads (-321.48)</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="check mark">✔️</span>Most Consistent Scorer</h3>
                <h4>Piss Jugman</h4>
              </div>
              <div>
                <h3><span role="img" aria-label="cross mark">❌</span>Least Consistent Scorer</h3>
                <h4>Charm City Trading Co.</h4>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row">
          <div className="inner">
            <h2>Total Points For</h2>
            <canvas id="chartPF"></canvas> 
            <div id="chartPF-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Total Points Possible</h2>
            <canvas id="chartPP"></canvas>
            <div id="chartPP-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>% of Possible Points Scored</h2>
            <canvas id="chartPercPP"></canvas>
            <div id="chartPercPP-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Total Points Against</h2>
            <canvas id="chartPA"></canvas>
            <div id="chartPA-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Team Average Score</h2>
            <canvas id="chartAvgScore"></canvas>
            <div id="chartAvgScore-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>% of Games with Above Average Score</h2>
            <canvas id="chartAboveAvgPerc"></canvas>
            <div id="chartAboveAvgPerc-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Highest Scores</h2>
            <canvas id="chartHighestScore"></canvas>
            <div id="chartHighestScore-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Weekly Finishes</h2>
            <canvas id="chartWeeklyPlaces"></canvas>
            <div id="chartWeeklyPlaces-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Percentage of Startup Draft Team</h2>
            <div className="chart-desc">(% of original team remaining)</div>
            <canvas id="chartOriginalTeam"></canvas>
            <div id="chartOriginalTeam-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Tier 1 Player Management</h2>
            <div className="chart-desc">(how many tier 1 players each team had)</div>
            <canvas id="chartTier1"></canvas>
            <div id="chartTier1-table-container"></div>
          </div>
        </div>

        <div className="row">
          <div className="inner">
            <h2>Weekly Reward Winners</h2>
            <table className="styled weekly-reward">
              <thead>
                <tr>
                  <th>Week</th>
                  <th>Title</th>
                  <th>Challenge</th>
                  <th>Winner</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>1</td>
                  <td>Ready Set Go</td>
                  <td>Team with the highest score</td>
                  <td>Take a poo leave a poo - 124.92</td>
                </tr>

                <tr>
                  <td>2</td>
                  <td>Air It Out</td>
                  <td>Team with the QB with the longest pass</td>
                  <td>Wee Lads - Lamar Jackson (55.9 yds)</td>
                </tr>

                <tr>
                  <td>3</td>
                  <td>Gotta Catch Em All</td>
                  <td>Team with the WR with the most receptions</td>
                  <td>Charm City Trading Co. - Puka Nacua (11)</td>
                </tr>

                <tr>
                  <td>4</td>
                  <td>Runt of the Litter</td>
                  <td>Winning team with the lowest scoring starter</td>
                  <td>Narcoleptic Skydivers - Ravens D/ST (-4 pts)</td>
                </tr>

                <tr>
                  <td>5</td>
                  <td>Got There</td>
                  <td>Team that beats its opponent by the smallest margin of victory</td>
                  <td>Charm City Trading Co. - 20.92 pts</td>
                </tr>

                <tr>
                  <td>6</td>
                  <td>Lockdown</td>
                  <td>Team with the least amount of yards given up on defense</td>
                  <td>Human Poop - Broncos (82 yds)</td>
                </tr>

                <tr>
                  <td>7</td>
                  <td>Blackjack</td>
                  <td>Team with a starter closest to 21 points without going over</td>
                  <td>Human Poop - Rashee Rice (19.7 pts)</td>
                </tr>

                <tr>
                  <td>8</td>
                  <td>Doing the Most</td>
                  <td>Team with the WR or TE with the highest yards after catch per reception (YAC/R)</td>
                  <td>D.P. LoveKraft - Tucker Kraft (18.6)</td>
                </tr>

                <tr>
                  <td>9</td>
                  <td>Magic Legs</td>
                  <td>Team with the RB with the most rushing yards</td>
                  <td>Charm City Trading Co. - Kyle Monangai (176 yds)</td>
                </tr>

                <tr>
                  <td>10</td>
                  <td>At Least You Tried</td>
                  <td>Highest scoring losing team</td>
                  <td>Narcoleptic Skydivers - 115.92 pts</td>
                </tr>

                <tr>
                  <td>11</td>
                  <td>To Completion</td>
                  <td>Team with the QB with the highest completion percentage</td>
                  <td>jhoffman - Dak Prescott (75.7%)</td>
                </tr>

                <tr>
                  <td>12</td>
                  <td>End Zone</td>
                  <td>Team with the most offensive touchdowns scored</td>
                  <td>Piss Jugman - 8</td>
                </tr>

                <tr>
                  <td>13</td>
                  <td>Efficient Zoomies</td>
                  <td>Team with the RB with the highest average rushing yards</td>
                  <td>Wee Lads - Blake Corum (11.6)</td>
                </tr>

                <tr>
                  <td>14</td>
                  <td>Consolation Prize</td>
                  <td>Team with the most points for on the season that didn't make the playoffs</td>
                  <td>Take a poo leave a poo - 1566.38</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div id="trades" className="row">
          <div className="inner">
            <h2>Trades</h2>

            <h3>Total Trades - {trades.length}</h3>
            <canvas id="chartTrades"></canvas>
            <div id="chartTrades-table-container"></div>
            
            <h3>Trade Details</h3>
            <div id="trades-details">
              {trades
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((data, id) => {
                  return <Trade key={id} data={data} teamNames={teamNames} />
                })
              }
            </div>
          </div>
        </div>
      </main>
    </React.Fragment>
  )
}

export default Page;